// @ts-strict

import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { LMDrillAroundNode } from '@components/drillaround/lm-drill-around-wc';

@Component({
  selector: 'lm-drill-point-view',
  templateUrl: './lm-drill-point-view.component.html',
  styleUrls: [ './lm-drill-point-view.component.scss'],
})
export class LMDrillPointViewComponent implements OnChanges, OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

  @Input() info!: LMDrillAroundViewInfo;
  @Input() selectedNode!: LMDrillAroundNode;

  @Output() drillActionSelectedEvent = new EventEmitter<LMDrillAroundNode>();
  @Output() drillAroundEvent = new EventEmitter<LMDrillAroundRequest>();

  isVisible = true;

  constructor() {
    // no-op
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['info']) {
      this.destroyAndReload();
    }
  }

  private destroyAndReload() {
    this.isVisible = false;

    setTimeout(() => {
      this.isVisible = true;
    }, 1);
  }

  ngOnInit(): void {
// no-op;
  }

  ngAfterViewInit(): void {
    // no-op
  }

  ngAfterViewChecked(): void {
    // no-op;
  }

  ngOnDestroy(): void {
    // no-op;
  }

  onDrillActionSelected(node: LMDrillAroundNode) {
    this.drillActionSelectedEvent.emit(node);
  }

  onDrillAround(event: LMDrillAroundRequest) {
    this.drillAroundEvent.emit(event);
  }
}
